import { VStack } from "@chakra-ui/layout";
import { Navbar } from "./components/Navbar";
import Head from "./components/Head";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Frontend from "./components/Skills/Frontend";
import Backend from "./components/Skills/Backend";
import Tools from "./components/Skills/Tools";
import VersionControl from "./components/Skills/VersionControl";
function App() {
	return (
		<VStack width={"full"}>
			<Navbar />
			<Head />
			<About />
			<Frontend />
			<Backend />
			<VersionControl />
			<Tools />
			<Projects />
			<Contact />
		</VStack>
	);
}

export default App;

// resume download
// logo
// Project Component
